import { parseUrl } from 'query-string'
import { sendClickLog } from '@/common/utils/log.v2.request'
import { getGnCode, getCurrentUrl, convertServiceType, getContentsUiCode, getEventAttrType, getUrlFromCellInfo, getTransactionKey, getServiceTypeFromCellInfo, getSecondLastPage } from '@/common/utils/log.v2.utils'
import { LOG_V2_ACTION_ITEM, LOG_V2_ACTION_TYPE, LOG_V2_CURRENT, LOG_V2_LANDING } from '@/common/resources/log.v2.const'
import { PATH_NAME_SEARCH_TAG } from '@/common/resources/router.const'

// NOTE: 1. 검색 메뉴 진입 /이탈 / 8. 검색결과(이탈) / 16. 태그검색결과 (이탈)
/**
 * (PC) [검색] 메뉴 클릭 시 / 태그검색결과 [검색] 클릭 시
 * @param router
 */
export function sendEventLogSearchOpen ({ route = {} }) {
  const isCurrentTagSearch = route?.name === PATH_NAME_SEARCH_TAG

  sendClickLog({
    current: isCurrentTagSearch ? LOG_V2_CURRENT.TAGSEARCH_RESULT : LOG_V2_CURRENT.GN51,
    currentUrl: getCurrentUrl(),
    actionType: isCurrentTagSearch
      ? LOG_V2_ACTION_TYPE.BUTTON_CLICK
      : LOG_V2_ACTION_TYPE.MENU_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.SEARCH_MENU,
    actionParam: isCurrentTagSearch
      ? { transactionKey: getTransactionKey() }
      : null,
    landing: LOG_V2_LANDING.SEARCH_MAIN,
    landingParam: null,
    landingUrl: '/search'
  }).catch(() => {})
}

/**
 * 검색 메인화면에서 인기 {인기시리즈|영화} 콘텐츠 클릭 시
 * @param cellInfo
 * @param index
 */
export function sendEventLogSearchPopularContents ({ cellInfo = {}, index = -1 }) {
  const contentType = getEventAttrType(cellInfo, 'contenttype')
  const contentId = getEventAttrType(cellInfo, 'uicode')
  const { url } = getUrlFromCellInfo(cellInfo)

  sendClickLog({
    current: LOG_V2_CURRENT.SEARCH_MAIN,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.CONTENT_CLICK,
    actionItem: contentType === 'program'
      ? LOG_V2_ACTION_ITEM.POPULAR_VOD_BAND
      : LOG_V2_ACTION_ITEM.POPULAR_MOVIE_BAND,
    actionParam: { type: `${contentType}_band` },
    landing: LOG_V2_LANDING.CONTENTS_DETAIL,
    landingParam: { contentid: contentId, idx: `${index}` },
    landingUrl: url
  }).catch(() => {})
}

/**
 * `${검색 메인화면|검색 결과|태그검색결과} 에서 GNB ${홈|카테고리|라이브|마이}클릭 시
 * @param name
 * @param route
 * @param landingUrl
 */
export function sendEventLogExitToGnb ({ name = '', route = {}, landingUrl = '' }) {
  const current = route?.name === PATH_NAME_SEARCH_TAG
    ? LOG_V2_CURRENT.TAGSEARCH_RESULT : route?.query?.searchWord
      ? LOG_V2_CURRENT.SEARCH_RESULT
      : LOG_V2_CURRENT.SEARCH_MAIN

  sendClickLog({
    current: current,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.MENU_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.GNB,
    actionParam: current === LOG_V2_CURRENT.SEARCH_MAIN
      ? null
      : { transactionKey: getTransactionKey() },
    landing: getGnCode(name),
    landingParam: null,
    landingUrl: landingUrl
  }).catch(() => {})
}

// NOTE: 2. 텍스트 검색 / 7. 검색결과 (재검색)
/**
 * {검색 키워드|검색결과 화면에서 검색어 재} 입력 후 [검색]버튼 클릭 시
 * @param keyword
 * @param landingUrl
 */
export function sendEventLogTextSearch ({ keyword = '', landingUrl = '' }) {
  const previousSearchWord = parseUrl(getCurrentUrl())?.query?.searchWord || ''

  sendClickLog({
    current: previousSearchWord
      ? LOG_V2_CURRENT.SEARCH_RESULT
      : LOG_V2_CURRENT.SEARCH_MAIN,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.BUTTON_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.TEXT_SEARCH,
    actionParam: previousSearchWord
      ? { keywords: keyword, transactionKey: getTransactionKey() }
      : null,
    landing: LOG_V2_LANDING.SEARCH_RESULT,
    landingParam: { keywords: keyword },
    landingUrl: landingUrl
  }).catch(() => {})
}

// NOTE: 3. 검색결과 (클릭) / 13. 태그검색결과 (클릭)
/**
 * 검색결과 [카테고리(메뉴)] 클릭 시
 * @param cellInfo
 * @param index
 */
export function sendEventLogSearchCategoryCell ({ cellInfo = {}, index = -1 }) {
  const contentId = getEventAttrType(cellInfo, 'uicode')
  const { url: landingURL } = getUrlFromCellInfo(cellInfo)

  sendClickLog({
    current: LOG_V2_CURRENT.SEARCH_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.CONTENT_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.CATEGORY_BAND,
    actionParam: { type: 'menu', transactionKey: getTransactionKey() },
    landing: contentId,
    landingParam: null,
    landingUrl: landingURL
  }).catch(() => {})
}

/**
 * {태그검색|검색} 결과 {프로그램|에피소드|라이브|영화|영화플러스|에디터픽|프로야구} 밴드 클릭 시
 * @param cellInfo
 * @param index
 * @param routeName
 */
export function sendEventLogSearchCell ({ cellInfo = {}, index = -1, routeName = '' }) {
  const isEditorPickCell = parseUrl(getCurrentUrl())?.query?.category === 'theme'
  const isTagSearch = routeName === PATH_NAME_SEARCH_TAG
  const contentType = getServiceTypeFromCellInfo(cellInfo) || 'theme' // todo: event_list 에 theme 이 내려오지 않아 빈 값일 경우 theme 으로 체크 (확인 필요) -> 검색 결과 에디터Pick 개별밴드 더보기 리스트에서 콘텐츠 클릭시 (1depth)
  const contentId = getEventAttrType(cellInfo, 'uicode')
  const { url: landingURL } = getUrlFromCellInfo(cellInfo)

  if (isEditorPickCell) {
    return sendEventLogSearchEditorPickList({ contentId: contentId, index: index, landingUrl: landingURL })
  } else {
    return sendClickLog({
      current: isTagSearch
        ? LOG_V2_CURRENT.TAGSEARCH_RESULT
        : LOG_V2_CURRENT.SEARCH_RESULT,
      currentUrl: getCurrentUrl(),
      actionType: LOG_V2_ACTION_TYPE.CONTENT_CLICK,
      actionItem: `${contentType}_band`,
      actionParam: { type: `${contentType}_band`, transactionKey: getTransactionKey() },
      landing: LOG_V2_LANDING.CONTENTS_DETAIL,
      landingParam: { contentid: contentId, idx: `${index}` },
      landingUrl: landingURL
    }).catch(() => {})
  }
}

/**
 * {태그 검색|검색} 결과 {프로그램|에피소드|라이브|영화|영화플러스} 더보기 리스트에서 콘텐츠 클릭 시
 * @param cellInfo
 * @param index
 * @param routeName
 */
export function sendEventLogSearchListCell ({ cellInfo = {}, index = -1, routeName = '' }) {
  const isTagSearch = routeName === PATH_NAME_SEARCH_TAG
  const serviceType = getServiceTypeFromCellInfo(cellInfo)
  const contentId = getEventAttrType(cellInfo, 'uicode')
  const { url: landingURL } = getUrlFromCellInfo(cellInfo)

  sendClickLog({
    current: isTagSearch
      ? LOG_V2_CURRENT.TAGSEARCH_RESULT
      : LOG_V2_CURRENT.SEARCH_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.CONTENT_CLICK,
    actionItem: `${serviceType}_band_view_more`,
    actionParam: { type: `${serviceType}_list`, transactionKey: getTransactionKey() },
    landing: LOG_V2_LANDING.CONTENTS_DETAIL,
    landingParam: { contentid: contentId, idx: `${index}` },
    landingUrl: landingURL
  }).catch(() => {})
}

/**
 * {검색 결과 에디터Pick(1depth)|에디터Pick 더보기 결과(3depth)} 개별밴드 더보기 리스트에서 콘텐츠 클릭시
 * @param cellInfo
 * @param index
 */
export function sendEventLogSearchEditorPickCell ({ cellInfo = {}, index = -1 }) {
  const isFromThemeList = parseUrl(getSecondLastPage())?.query?.category === 'theme'
  const contentId = getEventAttrType(cellInfo, 'uicode')
  const { url: landingURL } = getUrlFromCellInfo(cellInfo)

  sendClickLog({
    current: isFromThemeList
      ? LOG_V2_CURRENT.THEME_BAND_LIST
      : LOG_V2_CURRENT.SEARCH_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.CONTENT_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.THEME_BAND_VIEW_MORE,
    actionParam: { type: `theme_list`, transactionKey: getTransactionKey() },
    landing: LOG_V2_LANDING.CONTENTS_DETAIL,
    landingParam: { contentid: contentId, idx: `${index}` },
    landingUrl: landingURL
  }).catch(() => { })
}

/**
 * 검색 결과 에디터Pick 더보기 리스트에서 콘텐츠 클릭시 (2depth)
 * @param contentId
 * @param index
 * @param landingUrl
 */
export function sendEventLogSearchEditorPickList ({ contentId = '', index = -1, landingUrl = '' }) {
  sendClickLog({
    current: LOG_V2_CURRENT.SEARCH_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.CONTENT_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.THEME_MENU_VIEW_MORE,
    actionParam: { type: `theme_band`, transactionKey: getTransactionKey() },
    landing: LOG_V2_LANDING.CONTENTS_DETAIL,
    landingParam: { contentid: contentId, idx: `${index}` },
    landingUrl: landingUrl
  }).catch(() => {})
}

// NOTE: 4. 검색결과 (더보기 버튼 클릭) / 14. 태그검색결과 (더보기 버튼 클릭)
/**
 * {태그검색|검색} 결과 {프로그램|에피소드|라이브|영화|영화플러스|프로야구} 밴드 더보기 클릭 시
 * @param contentType
 * @param routeName
 * @param landingUrl
 */
export function sendEventLogSearchResultViewAll ({ contentType = '', routeName = '', landingUrl = '' }) {
  const serviceType = convertServiceType(contentType)

  sendClickLog({
    current: routeName === PATH_NAME_SEARCH_TAG
      ? LOG_V2_CURRENT.TAGSEARCH_RESULT
      : LOG_V2_CURRENT.SEARCH_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.VIEW_MORE_CLICK,
    actionItem: `${serviceType}_band`,
    actionParam: { type: `${serviceType}_band` },
    landing: routeName === PATH_NAME_SEARCH_TAG
      ? LOG_V2_LANDING.TAGSEARCH_RESULT
      : LOG_V2_LANDING.SEARCH_RESULT,
    landingParam: { type: `${serviceType}_list` },
    landingUrl: landingUrl
  }).catch(() => {})
}

/**
 * 검색결과 에디터 픽 더보기 클릭시 ({3depth|1depth})
 * @param themeId
 * @param routeQuery
 * @param landingUrl
 */
export function sendEventLogSearchResultThemeViewAll ({ themeId = '', routeQuery = '', landingUrl = '' }) {
  sendClickLog({
    current: routeQuery.category === 'theme'
      ? LOG_V2_CURRENT.THEME_BAND_LIST
      : LOG_V2_LANDING.SEARCH_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.VIEW_MORE_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.THEME_BAND,
    actionParam: { type: 'theme_band' },
    landing: LOG_V2_LANDING.THEME_LIST,
    landingParam: { themeid: `EN${themeId}` },
    landingUrl: landingUrl
  }).catch(() => {})
}

/**
 * 검색결과 에디터픽 더보기 클릭 시 (2depth)
 * @param landingUrl
 */
export function sendEventLogSearchResultEditorPickViewAll ({ landingUrl = '' }) {
  sendClickLog({
    current: LOG_V2_CURRENT.SEARCH_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.VIEW_MORE_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.THEME_MENU_VIEW_MORE,
    actionParam: null,
    landing: LOG_V2_LANDING.SEARCH_RESULT,
    landingParam: { type: 'theme_list' },
    landingUrl: landingUrl
  }).catch(() => {})
}

// NOTE: 5. 검색결과 (미수급 추천결과)
/**
 * 미수급 추천 결과 {프로그램|영화} 콘텐츠 클릭 시
 * @param cellInfo
 * @param index
 */
export function sendEventLogSearchRecommendCell ({ cellInfo = {}, index = -1 }) {
  const contentId = getEventAttrType(cellInfo, 'uicode')
  const { url: landingURL } = getUrlFromCellInfo(cellInfo)
  const serviceType = getServiceTypeFromCellInfo(cellInfo)

  sendClickLog({
    current: LOG_V2_CURRENT.RECOMMEND_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.CONTENT_CLICK,
    actionItem: serviceType === 'program'
      ? LOG_V2_ACTION_ITEM.RECOMMEND_PROGRAM_LIST
      : LOG_V2_ACTION_ITEM.RECOMMEND_MOVIE_LIST,
    actionParam: { type: `${serviceType}_list`, transactionKey: getTransactionKey() },
    landing: LOG_V2_LANDING.CONTENTS_DETAIL,
    landingParam: { contentid: contentId, idx: `${index}` },
    landingUrl: landingURL
  }).catch(() => {})
}

// NOTE: 6. 검색결과 (재정렬), 15. 태그검색결과 (재정렬)
/**
 * `{프로그램|에피소드|영화|영화플러스} {태그결과|결과} 리스트에서 정렬값 변경 시
 * @param current
 * @param contentType
 * @param selectedFilter
 * @param landingUrl
 */
export function sendEventLogSearchFilterChange ({ current = '', contentType = '', selectedFilter = '', landingUrl = '' }) {
  const serviceType = convertServiceType(contentType)

  sendClickLog({
    current: `${current === PATH_NAME_SEARCH_TAG ? 'tagsearch_' : ''}${serviceType}_list`,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.ORDER_BY,
    actionItem: null,
    actionParam: { type: selectedFilter, transactionKey: getTransactionKey() },
    landing: null,
    landingParam: null,
    landingUrl: landingUrl
  }).catch(() => {})
}

// NOTE: 8. 검색결과 (이탈)
/**
 * 검색결과에서 입력한 검색어 옆의 [x] 버튼 클릭 시
 */
export function sendEventLogDeleteSearchKeyword () {
  sendClickLog({
    current: LOG_V2_CURRENT.SEARCH_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.BUTTON_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.SEARCH_TEXT_CANCEL,
    actionParam: { transactionKey: getTransactionKey() },
    landing: LOG_V2_LANDING.SEARCH_MAIN,
    landingParam: null,
    landingUrl: null
  }).catch(() => {})
}

// NOTE: 9. 추천 검색어
/**
 * 검색결과 없을 경우 노출되는 추천 검색어 클릭 시
 * @param keyword
 * @param landingUrl
 */
export function sendEventLogSearchRecommendTag ({ keyword = '', landingUrl = '' }) {
  sendClickLog({
    current: LOG_V2_CURRENT.NO_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.KEYWORD_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.RECOMMEND_KEYWORDS,
    actionParam: null,
    landing: getContentsUiCode(landingUrl),
    landingParam: { keywords: keyword, themeid: getContentsUiCode(landingUrl) },
    landingUrl: landingUrl
  }).catch(() => {})
}

// NOTE: 10. 자동완성 검색어
/**
 * 검색 키워드 입력 중 자동완성 콘텐츠를 클릭 시
 * @param cellInfo
 * @param index
 */
export function sendEventLogAutoCompleteContents ({ cellInfo = {}, index = -1 }) {
  const contentId = getEventAttrType(cellInfo, 'uicode')
  const { url: landingURL } = getUrlFromCellInfo(cellInfo)

  sendClickLog({
    current: LOG_V2_CURRENT.SEARCH_MAIN,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.CONTENT_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.AUTO_COMPLETION_KEYWORDS,
    actionParam: null,
    landing: LOG_V2_LANDING.CONTENTS_DETAIL,
    landingParam: { contentid: contentId, idx: index },
    landingUrl: landingURL
  }).catch(() => {})
}

// NOTE: 11. 태그검색 메뉴 진입/이탈
/**
 * 검색 메인화면에서 {시리즈(프로그램)|영화} 태그검색 클릭 시
 * @param type
 */
export function sendEventLogShowTagSearchPopup ({ type = '' }) {
  sendClickLog({
    current: LOG_V2_CURRENT.SEARCH_MAIN,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.MENU_CLICK,
    actionItem: type === 'movie'
      ? LOG_V2_ACTION_ITEM.TAGSEARCH_MOVIE
      : LOG_V2_ACTION_ITEM.TAGSEARCH_VOD,
    actionParam: null,
    landing: type === 'movie'
      ? LOG_V2_LANDING.TAGSEARCH_MAIN_MOVIE
      : LOG_V2_LANDING.TAGSEARCH_MAIN_VOD,
    landingParam: null,
    landingUrl: getCurrentUrl()
  }).catch(() => {})
}

/**
 * {시리즈|영화} 태그검색 화면에서 [닫기] 클릭 시
 * @param type
 */
export function sendEventLogCloseTagSearchPopup ({ type = '' }) {
  sendClickLog({
    current: type === 'movie'
      ? LOG_V2_CURRENT.TAGSEARCH_MAIN_MOVIE
      : LOG_V2_CURRENT.TAGSEARCH_MAIN_VOD,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.BUTTON_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.CLOSE,
    actionParam: null,
    landing: LOG_V2_LANDING.SEARCH_MAIN,
    landingParam: null,
    landingUrl: getCurrentUrl()
  }).catch(() => {})
}

// NOTE: 12. 태그검색
/**
 * ${시리즈|영화} 태그 선택하고 [검색] 버튼 클릭 시
 * @param type
 * @param tagDataList
 * @param landingUrl
 */
export function sendEventLogTagSearch ({ type = '', tagDataList = [], landingUrl = '' }) {
  const tagList = tagDataList.map(tag => (tag.match(/(\|)(.*?)(\|)/gi) || []).join().replaceAll('|', ''))

  sendClickLog({
    current: type === 'movie'
      ? LOG_V2_CURRENT.TAGSEARCH_MAIN_MOVIE
      : LOG_V2_CURRENT.TAGSEARCH_MAIN_VOD,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.BUTTON_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.TAG_SELECT,
    actionParam: null,
    landing: LOG_V2_LANDING.TAGSEARCH_RESULT,
    landingParam: { tags: tagList },
    landingUrl: landingUrl
  }).catch(() => {})
}

// 17. 태그검색결과 (재검색)
/**
 * {시리즈|영화} 태그검색결과 [태그 재검색] 클릭 시
 * @param type
 */
export function sendEventLogTagReSearch ({ type = '' }) {
  const tagType = (type === 'broadcast') ? 'vod' : type

  sendClickLog({
    current: LOG_V2_CURRENT.TAGSEARCH_RESULT,
    currentUrl: getCurrentUrl(),
    actionType: LOG_V2_ACTION_TYPE.BUTTON_CLICK,
    actionItem: LOG_V2_ACTION_ITEM.TAG_RESEARCH,
    actionParam: { type: `tag_${tagType}`, transactionKey: getTransactionKey() },
    landing: tagType === 'movie'
      ? LOG_V2_LANDING.TAGSEARCH_MAIN_MOVIE
      : LOG_V2_LANDING.TAGSEARCH_MAIN_VOD,
    landingParam: null,
    landingUrl: getCurrentUrl()
  }).catch(() => {})
}
